import React from 'react';
import Image from 'react-bootstrap/Image';
import { useTranslation } from 'react-i18next';
import { differenceInDays } from 'date-fns';
import isEmpty from 'lodash-es/isEmpty';

import comapnyLogo from '../../../../assets/images/CompanyDefaultLogo.svg';
import { ReactComponent as LocationIcon } from '../../../../assets/images/location-icon.svg';
import LabelWithIcon from '../../../../components/shared/Label/LabelWithIcon';
import { getDateTimeFromNow, isDateValid, locationObjToStr, renderSalaryRange } from '../../../../helpers/commonHelper';
import JobInfoSection from '../../OpeningsListElement/JobInfoSection';
import DepartmentIcon from '../../Shared/DepartmentIcon/DepartmentIcon';

import styles from './OpeningJobHeader.module.scss';

const OpeningJobHeader = ({
  title = '',
  oragnizationName = '',
  location = {},
  minSalary,
  maxSalary,
  currency_id,
  logo = '',
  work_place_type,
  category = '',
  work_type,
  publishedDate,
  job_urgency_type_name,
  job_experience_name,
  redirectToOrg,
}) => {
  const { t } = useTranslation('common');
  const date = getDateTimeFromNow(publishedDate);
  const PublishedDays = differenceInDays(new Date(), new Date(publishedDate));
  const salaryRange = renderSalaryRange(minSalary, maxSalary, currency_id);

  return (
    <div className={styles.whiteContainer}>
      <div className={styles.headingContainer}>
        <div className={styles.ImageContainer}>
          <button type="button" onClick={redirectToOrg} className={styles.AvatarImage}>
            <Image src={logo ?? comapnyLogo} alt="company logo" className={styles.logo} />
            {category === 'department' && <DepartmentIcon departmentContainer={styles.departmentIconDiv} />}
          </button>
        </div>
        <div className={styles.headingDetails}>
          <div className={styles.jobNewLabelContainer}>
            <div className={styles.jobTitle}>{title}</div>
            {PublishedDays < 3 && (
              <LabelWithIcon varient="label-new" tag={t('labels.new')} textClassName={styles.newLabelText} />
            )}
          </div>
          <span className={styles.oragnizationName} onClick={redirectToOrg} role="presentation">
            {oragnizationName}
          </span>
          <div className={styles.locationContainer}>
            {!isEmpty(location) && (
              <>
                <LocationIcon />
                <span className={styles.location}>{locationObjToStr(location)}</span>
                {!isEmpty(salaryRange) ? <span className={styles.verticalLine} /> : null}
              </>
            )}
            {!isEmpty(salaryRange) ? (
              <span className={styles.salaryRange}>
                {salaryRange}
                <span className={styles.salaryText}>({t('browse.salary')})</span>
              </span>
            ) : null}
          </div>
          <div className={styles.tagDaysContainer}>
            <JobInfoSection
              work_place_type={work_place_type}
              work_type={work_type}
              job_experience_name={job_experience_name}
              job_urgency_type_name={job_urgency_type_name}
            />
            <span className={styles.jobDays}>{isDateValid(publishedDate) && date}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OpeningJobHeader;
